import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Headroom from "react-headroom";
import classNames from "classnames/bind";
import styles from "./index.css";
import FilterLayoutContainer from "../FilterLayout";
import SortLayoutContainer from "../SortLayout";
import SmallScreenSort from "../Sort/SmallScreenSort";
import SortListContainer from "../Sort/SortList";
import RefinementListContainer from "../RefinementsList";
import getPinStart from "./getPinStart";
import { showFilterOverlay } from "../../state/modules/layout/actions";
import { hasSelectedFacets } from "../../state/modules/search/selectors";
import { withTranslation } from "../translation/";

const combineClasses = classNames.bind(styles);

export const SmallScreenHeader = ({ formatTranslation }) => {
  const dispatch = useDispatch();
  const hasSelectedFacetsValue = useSelector(hasSelectedFacets);

  return (
    <div className={styles.container}>
      <Headroom
        className={styles.stickyHeader}
        disableInlineStyles={true}
        pinStart={getPinStart}
        upTolerance={17}
      >
        <div className={styles.sortControls}>
          <SmallScreenSort />
        </div>
        <div className={styles.filterControls}>
          <button
            className={combineClasses({
              filterButton: true,
              filterButton_checked: hasSelectedFacetsValue
            })}
            onClick={() => dispatch(showFilterOverlay())}
          >
            {formatTranslation("plp_web_search_filter_label")}
          </button>
        </div>
      </Headroom>
      <FilterLayoutContainer>
        <RefinementListContainer />
      </FilterLayoutContainer>
      <SortLayoutContainer>
        <SortListContainer />
      </SortLayoutContainer>
    </div>
  );
};

SmallScreenHeader.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(SmallScreenHeader);
